"use client"

import { ProductCategory } from "@medusajs/medusa"
import Link from "next/link"
import { useMemo, useState } from "react"

import { buildRoute } from "@lib/routes"

import { LeftChevron } from "../../icons/LeftChevron"
import { RightChevron } from "../../icons/RightChevron"

interface MobileCategoriesContentProps {
  categories: ProductCategory[]
}

const MobileCategoriesContent = ({ categories }: MobileCategoriesContentProps) => {
  const [selectedCategory, setSelectedCategory] = useState<ProductCategory | null>(null)

  const sortedCategories = useMemo(
    () => [...categories].sort((a, b) => b.category_children.length - a.category_children.length),
    [categories]
  )

  return (
    <nav className="absolute left-0 top-[64px] z-50 flex h-[calc(100dvh-64px)] w-full bg-white">
      <div className="content-container w-full grow overflow-y-auto pb-8">
        {selectedCategory ? (
          <div className="w-full">
            <button
              onClick={() => setSelectedCategory(null)}
              className="sticky top-0 z-10 flex w-full items-center gap-4 bg-white py-[13px] text-left leading-[20px] hover:bg-nelo-mid-gray"
            >
              <LeftChevron /> Regresar
            </button>
            <div className="divide-y border-t pb-8">
              <Link
                className="block w-full py-[14px] leading-[20px] tracking-[-2%] hover:bg-nelo-mid-gray"
                href={buildRoute.category(selectedCategory.handle)}
              >
                {selectedCategory.name}
              </Link>
              {selectedCategory.category_children.map((category) => (
                <Link
                  className="block w-full py-[14px] leading-[20px] tracking-[-2%] hover:bg-nelo-mid-gray"
                  key={category.id}
                  href={buildRoute.category([selectedCategory.handle, category.handle])}
                >
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        ) : (
          <div className="w-full divide-y bg-white">
            <p className="sticky top-0 z-10 block w-full bg-white py-[13px] font-semibold leading-[20px]">Explora las categorías</p>
            <div className="pb-8">
              {sortedCategories.map((category) =>
                category.category_children.length > 0 ? (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category)}
                    className="flex w-full items-center justify-between py-[13px] text-left leading-[20px] hover:bg-nelo-mid-gray"
                  >
                    {category.name}
                    <RightChevron />
                  </button>
                ) : (
                  <Link
                    key={category.id}
                    href={buildRoute.category(category.handle)}
                    className="block w-full py-[14px] leading-[20px] tracking-[-2%] hover:bg-nelo-mid-gray"
                  >
                    {category.name}
                  </Link>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default MobileCategoriesContent
